import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { ContainerSmall } from "@/components/primitives/container-small";
import { PageContainer } from "@/components/primitives/layout";
import { DiscoverRecipesLanding } from "@/components/views/discover/discover-recipes-list";
import { auth } from "@/lib/auth";

const HIGH_QUALITY_PREVIEW_LIMIT = 6;

const getDiscoverData = createServerFn({ method: "GET" }).handler(async () => {
  const request = getRequest();
  const session = await auth.api.getSession({ headers: request.headers });
  const userId = session?.user?.id ?? null;
  const { getPublicRecipes, getPublicRecipeCount } =
    await import("@/lib/api/getPublicRecipes.server");

  const [highQualityRecipesResponse, totalPublicRecipes] = await Promise.all([
    getPublicRecipes({
      highQuality: true,
      limit: HIGH_QUALITY_PREVIEW_LIMIT,
      userId,
    }),
    getPublicRecipeCount(),
  ]);

  return { highQualityRecipesResponse, totalPublicRecipes };
});

export const Route = createFileRoute("/discover/")({
  head: () => ({
    meta: [
      { title: "Discover Recipes - Scoopulator" },
      {
        name: "description",
        content: "Browse ice cream recipes shared by the community.",
      },
    ],
  }),
  loader: () => getDiscoverData(),
  component: DiscoverRecipesPage,
});

function DiscoverRecipesPage() {
  const { highQualityRecipesResponse, totalPublicRecipes } =
    Route.useLoaderData();

  return (
    <PageContainer gradient>
      <ContainerSmall>
        <DiscoverRecipesLanding
          totalPublicRecipes={totalPublicRecipes}
          highQualityRecipes={highQualityRecipesResponse.recipes}
        />
      </ContainerSmall>
    </PageContainer>
  );
}
